const getSelectedOffering = (offerings, filteredOfferingTitles = [])=>{
    if (!offerings || offerings.length === 0) return undefined;
    const selectedOffering = offerings.find((offering)=>offering.title === filteredOfferingTitles[0]
    );
    return selectedOffering !== null && selectedOffering !== void 0 ? selectedOffering : offerings[0];
};

export { getSelectedOffering };
//# sourceMappingURL=get-selected-offering.js.map
